import { ref, watch, onBeforeUnmount } from 'vue'
import { webApi } from '../services/webApi'
import { authStorage } from '../services/http'

export const balanceTreasureAvailabilityKey = Symbol('balanceTreasureAvailability')
export const balanceTreasureInterestType = 'BALANCE_TREASURE_INTEREST'
// Only the current enabled interest activity controls the interest account entry.
export function balanceTreasureInterestOpen(items) {
  return Array.isArray(items) && items.some(item => item?.activityType === balanceTreasureInterestType && item.status === 1)
}
export function useBalanceTreasureAvailability(identity) {
  const available = ref(null), error = ref('')
  let sequence = 0
  async function refresh() {
    const ticket = ++sequence, token = authStorage.getToken()
    error.value = ''
    if (!identity.isLoggedIn.value) { available.value = false; return }
    try {
      const items = await webApi.activities({ activityType: balanceTreasureInterestType })
      if (ticket === sequence && token === authStorage.getToken()) available.value = balanceTreasureInterestOpen(items)
    } catch (reason) {
      if (ticket === sequence && token === authStorage.getToken()) { available.value = false; error.value = reason.message || '活动状态查询失败' }
    }
  }
  function visibleRefresh() { if (document.visibilityState === 'visible' && identity.isLoggedIn.value) void refresh() }
  watch([identity.isLoggedIn, () => identity.userName?.value], () => { available.value = null; void refresh() }, { immediate: true })
  if (identity.currentPath) watch(identity.currentPath, visibleRefresh)
  window.addEventListener('focus', visibleRefresh)
  document.addEventListener('visibilitychange', visibleRefresh)
  const timer = window.setInterval(visibleRefresh, 30000)
  onBeforeUnmount(() => { ++sequence; window.clearInterval(timer); window.removeEventListener('focus', visibleRefresh); document.removeEventListener('visibilitychange', visibleRefresh) })
  return { available, error, refresh }
}
